import { render, staticRenderFns } from "./role_form.vue?vue&type=template&id=6a3f660a&scoped=true"
import script from "./role_form.vue?vue&type=script&lang=js"
export * from "./role_form.vue?vue&type=script&lang=js"
import style0 from "./role_form.vue?vue&type=style&index=0&id=6a3f660a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3f660a",
  null
  
)

/* custom blocks */
import block0 from "./role_form.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports